export enum sellYourPropertyUploadDocumentTabTypes {
    None = "None",
    RequiredDocument = "RequiredDocument",
    AdditionalDocument = "AdditionalDocument",
    PictureDocument = "PictureDocument",
    PropertyInfoDocument = "PropertyInfoDocument",
    NewAddedAdditionalDocument = "NewAddedAdditionalDocument",
}